import React, {useState, useEffect} from 'react';
import ButtonTransparent from "@atoms/button.transparent";
import Icon from "@atoms/icon";
import RefreshIcon from '@icons/refresh.svg'
import {isEmpty} from "@helpers/helpers";
import {getCaptcha} from "@models/captcha";
import CircleLoading from "../lotties/circle_loading";


function Captcha({token, captchaValue, error, className, handleChange, handleForceRefreshCaptcha}) {
    const [captcha, setCaptcha] = useState('');
    const [receiving, setReceiving] = useState(false);

    const handleCaptcha = () => {
        setCaptcha('');
        getCaptcha(token).then(result => {
            setCaptcha(result.image);
            setReceiving(false);
        }).catch(err => {
            if (typeof handleForceRefreshCaptcha !== "undefined") {
                handleForceRefreshCaptcha();
            }

            setReceiving(false);
        })
    };

    useEffect(() => {
        if (!isEmpty(token) && !receiving) {
            setReceiving(true);
            handleCaptcha()
        }
    }, [token]);

    return (
        <div className={"row " + (className ? className : '')}>
            <div className="col-12 mb-8">
                <span>اعداد تصویر رو در کادر زیر وارد کنید:</span>
            </div>
            <div className="col-6">
                <input type="tel" name="captcha" autoComplete="off" onChange={handleChange} value={captchaValue} className={"form-control text-center ltr " + (!isEmpty(error) ? 'is-invalid' : '')}/>
                {
                    !isEmpty(error) ?
                        <div className="invalid-feedback">
                            {error}
                        </div>
                        : ''
                }
            </div>

            <div className="col-6 d-flex align-items-center justify-content-between">

                {
                    (!isEmpty(captcha)) ?
                        <img src={captcha} alt="loading" width="88"/>
                        :
                        <CircleLoading width={32} height={32}/>
                }


                <ButtonTransparent onClick={() => handleCaptcha()} className="line-height-0">
                    <Icon width={20} height={20} className="captcha-refresh">
                        <RefreshIcon/>
                    </Icon>
                </ButtonTransparent>
            </div>
        </div>
    )
}

export default React.memo(Captcha)